import style from "./style.module.scss";
import { Color } from "@/src/styles/typescript/types/color";

export default function Divider({
  variant = "line",
  color = "white-smoke-1",
}: {
  variant?: "line" | "dashed";
  color?: Color;
}) {
  return (
    <hr
      className={`${
        variant === "line" ? style["divider-line"] : style["divider-dashed"]
      } ${style["divider-color--" + color]} `}
    />
  );
}
